import { Card, Col, Typography, Button, List, Tag, Space } from "antd"
import {
  BulbOutlined
} from "@ant-design/icons"

const { Text } = Typography

const SignalQueue = () => {
  // Proactive Signals
  const proactiveSignals = [
    {
      key: "1",
      signal: "Supplier consolidation trend",
      opportunity: "$280K savings",
      confidence: "87%",
      type: "cost-optimization",
    },
    {
      key: "2",
      signal: "Competitor pricing shift detected",
      opportunity: "Market share gain",
      confidence: "92%",
      type: "market-opportunity",
    },
    {
      key: "3",
      signal: "Regulatory change incoming",
      opportunity: "Compliance advantage",
      confidence: "78%",
      type: "regulatory",
    },
  ]
  return (
    <Card
      title={
        <Space>
          <BulbOutlined style={{ color: "#faad14" }} />
          <span>Proactive Signal Queue</span>
        </Space>
      }
    >
      <List
        dataSource={proactiveSignals}
        renderItem={(item) => (
          <List.Item
            key={item.key}
            actions={[
              <Button type="primary" size="small">
                Pre-approve
              </Button>,
              <Button size="small">Assign Team</Button>,
              <Button size="small">Delay</Button>,
            ]}
          >
            <List.Item.Meta
              title={
                <Space>
                  <Text strong>Signal: {item.signal}</Text>
                  <Tag color="green">{item.confidence} confidence</Tag>
                </Space>
              }
              description={`Potential: ${item.opportunity}`}
            />
          </List.Item>
        )}
      />
    </Card>
  )
}

export default SignalQueue